import { render, staticRenderFns } from "./LiveStat.vue?vue&type=template&id=315835e8&"
import script from "./LiveStat.vue?vue&type=script&lang=js&"
export * from "./LiveStat.vue?vue&type=script&lang=js&"
import style0 from "./LiveStat.vue?vue&type=style&index=0&id=315835e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports